export default "__VITE_ASSET__BVKkU$l5__"